import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import { IIcon, IPageInfo } from '../../../../core/interfaces/interface';
import { SharedModule } from '../../../../shared/shared-module';
import { TranslateModule } from '../../../../shared/modules/translate/translate.module';

@Component({
  selector: 'app-tools-jumbotron',
  templateUrl: './tools-jumbotron.component.html',
  styleUrl: './tools-jumbotron.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule, TranslateModule],
})
export class ToolsJumbotronComponent {
  @Input() icons?: IIcon[];

  @Input() latestUpdate?: Date;
  @Input('text-alignment') textAlignment = 'text-center';

  @Input() pageInfo: IPageInfo = {} as any;
  constructor() { }
}
